"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThrowMagneticBombAbilityHandler = exports.ThrowMagneticBombActorAbilityFactory = exports.ThrowMagneticBombAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ThrowMagneticBombAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ThrowMagneticBomb;
        this.__typeName = "ThrowMagneticBomb";
    }
}
exports.ThrowMagneticBombAbilityArgs = ThrowMagneticBombAbilityArgs;
let ThrowMagneticBombActorAbilityFactory = class ThrowMagneticBombActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ThrowMagneticBomb", "AllEnemies", 3);
    }
};
ThrowMagneticBombActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ThrowMagneticBomb")
], ThrowMagneticBombActorAbilityFactory);
exports.ThrowMagneticBombActorAbilityFactory = ThrowMagneticBombActorAbilityFactory;
let ThrowMagneticBombAbilityHandler = class ThrowMagneticBombAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            sequence,
            targets: targets.map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Fire", 80)
                ]
            }))
        });
    }
};
ThrowMagneticBombAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ThrowMagneticBomb)
], ThrowMagneticBombAbilityHandler);
exports.ThrowMagneticBombAbilityHandler = ThrowMagneticBombAbilityHandler;
